<div class="feedback-detail-container">
  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <div class="spinner"></div>
    <p>Loading survey feedback...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="error-container">
    <div class="error-icon">⚠️</div>
    <p>{{ error }}</p>
    <button class="back-btn-error" (click)="goBack()">
      <i class="fas fa-arrow-left"></i> Back to Feedback List
    </button>
  </div>

  <!-- Main Content -->
  <div *ngIf="!loading && !error && surveyDetail" class="content">
    <!-- Header Section -->
    <div class="header-section">
      <div class="survey-info">
        <div class="survey-title-row">
          <h1>{{ surveyDetail.survey_title }}</h1>
          <span class="survey-number">{{ surveyDetail.survey_number }}</span>
        </div>
        <p class="survey-description" *ngIf="surveyDetail.survey_description">
          {{ surveyDetail.survey_description }}
        </p>
      </div>

      <div class="stats-container">
        <div class="stat-card">
          <div class="stat-value">{{ surveyDetail.total_completed }}</div>
          <div class="stat-label">Responses</div>
        </div>
        <div class="stat-card">
          <div class="stat-value">{{ surveyDetail.total_assigned }}</div>
          <div class="stat-label">Assigned</div>
        </div>
        <div class="stat-card">
          <div class="stat-value">{{ getCompletionPercentage() }}%</div>
          <div class="stat-label">Completion</div>
        </div>
      </div>

      <!-- <button class="export-btn" (click)="exportToExcel()" *ngIf="responses.length > 0">
        <span class="export-icon">📥</span>
        Export to Excel
      </button> -->
    </div>

    <!-- No Responses State -->
    <div *ngIf="responses.length === 0" class="no-responses">
      <div class="no-responses-icon">📋</div>
      <h3>No Feedback Received Yet</h3>
      <p>This survey hasn't received any responses yet.</p>
    </div>

    <!-- Responses Content -->
    <div *ngIf="responses.length > 0" class="responses-section">
      <!-- Responses List (Sidebar) -->
      <div class="responses-list">
        <h3 class="list-title">Customer Responses ({{ responses.length }})</h3>
        <div class="response-items">
          <div
            *ngFor="let response of responses"
            class="response-item"
            [class.active]="selectedResponse?._id === response._id"
            (click)="selectResponse(response)"
          >
            <div class="response-customer">
              <div class="customer-icon">👤</div>
              <div class="customer-info">
                <div class="customer-name">{{ response.customer_name }}</div>
              </div>
            </div>
            <div class="response-date">{{ formatDate(response.conducted_date) }}</div>
            <div class="response-by" *ngIf="response.conducted_by_employee_name">
              Conducted by: {{ response.conducted_by_employee_name }}
            </div>
          </div>
        </div>
      </div>

      <!-- Response Detail (Main Panel) -->
      <div class="response-detail" *ngIf="selectedResponse">
        <div class="detail-header">
          <div class="detail-customer">
            <h2>{{ selectedResponse.customer_name }}</h2>
          </div>
          <div class="detail-meta">
            <div class="meta-item">
              <span class="meta-label">Conducted Date:</span>
              <span class="meta-value">{{ formatDate(selectedResponse.conducted_date) }}</span>
            </div>
            <div class="meta-item" *ngIf="selectedResponse.conducted_by_employee_name">
              <span class="meta-label">Conducted By:</span>
              <span class="meta-value">{{ selectedResponse.conducted_by_employee_name }}</span>
            </div>
          </div>
        </div>

        <!-- Questions and Answers -->
        <div class="answers-container">
          <div
            *ngFor="let set of surveyDetail.questionnaire_sets"
            class="question-set"
          >
            <h3 class="set-name">{{ set.set_name }}</h3>

            <div
              *ngFor="let answer of selectedResponse.answers"
              class="answer-item"
            >
              <ng-container *ngIf="answer.set_id === set.set_id">
                <ng-container *ngIf="getQuestion(set.set_id, answer.question_id) as question">
                  <div class="question-text">
                    {{ question.question_text }}
                    <span class="question-type-badge" [ngClass]="question.question_type">
                      {{ question.question_type.replace('_', ' ') }}
                    </span>
                  </div>

                  <!-- Star Rating Display -->
                  <div class="answer-value" *ngIf="answer.star_rating !== undefined">
                    <div class="star-rating">
                      <span
                        *ngFor="let star of getStarArray(answer.star_rating)"
                        class="star"
                        [class.filled]="star <= answer.star_rating"
                      >
                        ★
                      </span>
                      <span class="rating-value">({{ answer.star_rating }}/5)</span>
                    </div>
                  </div>

                  <!-- Text Answer Display -->
                  <div class="answer-value text-answer" *ngIf="answer.text_answer">
                    <p>{{ answer.text_answer }}</p>
                  </div>

                  <!-- Multiple Choice Display -->
                  <div class="answer-value choice-answer" *ngIf="answer.selected_option">
                    <div class="selected-option">
                      <span class="checkmark">✓</span>
                      {{ answer.selected_option }}
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- Remarks Section -->
        <div class="remarks-section" *ngIf="selectedResponse.remarks">
          <h4 class="remarks-title">Additional Remarks</h4>
          <div class="remarks-content">
            {{ selectedResponse.remarks }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>